import { ModalSelectDate } from "./modalSelectDate.js";
import { ModalTiteledWindow } from "./modalWindow.js";
import { ModalShowDayAbsenceDetails } from "./modalShowDayAbsenceDetails.js";
import { RadioButtons } from "../radiobuttons.js";
import { groupData, sortObjectArray } from "../util.js";

export class ModalShowDayAbsences extends ModalTiteledWindow {

   constructor(app, cls) {
      super();
      this.app = app;
      this.class = cls;
      this.addClass('modal-show-day-absences');
      this.addClass('modal-show-absences');
      this.setTitle(`Fehltage ${this.class.name}`);
      this.sortKeys = [];

      this.setBody(`
         <div class="select">
            <span class="help icon-info" selector=".modal-day-absences" style="position: absolute; right: 0.5rem;"></span>
            <span>
               <span class="print icon-print" style="font-size: 1.2rem" onclick="window.print()"></span>
               <span class="save icon-download" style="font-size: 1.2rem"></span>
            </span>
            <div class="years"></div>
            <div class="date-range">
               <div class="range">
                  von 
                  <div class="date date-from" date="from"></div>
                  bis
                  <div class="date date-to" date="to"></div>
               </div>
            </div>

         </div>

         <div class="absences"></div>
      `);

      this.dateRange = new RadioButtons('date-range', {
            onSelect: (value) => this.setRangeType(value)
         },
         [
            { label: "Schuljahr", value: "full-year" },
            { label: "Zeitraum",  value: "date-range" },
         ]
      );
      this.panel.querySelector('.select .date-range').prepend(this.dateRange.getElement());

      this.elDateFrom = this.panel.querySelector('.date-range .date-from');
      this.elDateTo = this.panel.querySelector('.date-range .date-to');

      [this.elDateFrom, this.elDateTo].forEach(el => el.onclick = (event) => {
         const elDate = event.currentTarget;
         new ModalSelectDate({ onSelect: (value) => {
            elDate.dataset.date = value.isoDate();
            elDate.innerText = value.toGermanDate();
            localStorage.setItem('sek1AbsenceDatesRange', JSON.stringify({ from: this.elDateFrom.dataset.date, to: this.elDateTo.dataset.date }));
            this.loadAbsences();
         }});
      });

      this.dateRange.setValue('full-year', true);

      setTimeout(() => this.show(), 1);

      this.setupHelp(this.app);

   }

   setRangeType(type) {

      this.sortKeys = ['<.normedLastName', '<.normedFirstName'];

      if (type === 'full-year') {
         this.panel.querySelector('.date-range .range').style.display = 'none';
         this.loadAbsences();
      }
      else {

         let range;
         try {
            range = JSON.parse(localStorage.getItem('sek1AbsenceDatesRange'));
            if (!range) throw new Error();
         }
         catch(e)  { range = { from: (new Date()).isoDate(), to: (new Date()).isoDate() }; }

         this.panel.querySelector('.date-range .range').style.display = 'flex';

         this.elDateFrom.dataset.date = range.from;
         this.elDateFrom.innerText = Date.fromString(range.from).toGermanDate();
         this.elDateTo.dataset.date = range.to;
         this.elDateTo.innerText = Date.fromString(range.to).toGermanDate();

         this.loadAbsences();

      }

   }

   async loadAbsences() {

      const data = await this.app.dm.sinRequest({
         action: 'cls-get-absences',
         classId: this.class.id,
         output: 'object'
      });

      if (this.dateRange.getValue() !== 'full-year') {
         const dateFrom = this.elDateFrom.dataset.date;
         const dateTo = this.elDateTo.dataset.date;
         data.data = data.data.filter(abs => abs.date.isBetween(dateFrom, dateTo));
      }

      this.data = data.data;
      
      this.updateAbsences();

   }

   updateAbsences() {

      const year = this.app.dm.getCurrentYear();
      let data = groupData(this.data, ['pupilId'],
         (group) => { group.justified1 = 0; group.notJustified1 = 0, group.justified2 = 0; group.notJustified2 = 0 },
         (group, item) => {
            if (item.date >= year.dateFrom && item.date < year.dateHj2) {
               if (item.justified) group.justified1 += item.factor;
               else group.notJustified1 += item.factor;
            }
            else if (item.date >= year.dateHj2  && item.date < year.dateTo) {
               if (item.justified) group.justified2 += item.factor;
               else group.notJustified2 += item.factor;
            }
         }
      );

      this.pupils = this.class.pupils.map(pupilId => {
         let pupil = this.app.dm.getUser(pupilId);
         const abs = data.find(item => item.pupilId === pupil.id);
         if (abs) {
            pupil.absences = [
               [ Math.round(abs.justified1), Math.round(abs.notJustified1), Math.round(abs.justified1) + Math.round(abs.notJustified1)],
               [ Math.round(abs.justified2), Math.round(abs.notJustified2), Math.round(abs.justified2) + Math.round(abs.notJustified2)],
            ];
            pupil.absences.push([ pupil.absences[0][0] + pupil.absences[1][0], pupil.absences[0][1] + pupil.absences[1][1], pupil.absences[0][2] + pupil.absences[1][2] ]);
         }
         else pupil.absences = [ [0,0,0], [0,0,0], [0,0,0] ];
         return pupil;
      });

      if (!this.sortKeys.includes('<.normedLastName')) this.sortKeys.push('<.normedLastName');

      sortObjectArray(this.pupils, this.sortKeys);

      let html = `
        <table class="bl-2 br-2 bt-2 bb-2"><thead>
            <tr>
            <th></th><th></th><th colspan="3" class="bl-2">1. HJ</th><th colspan="3" class="bl-2">2. HJ</th><th colspan="3" class="bl-2 br-2">gesamt</th></tr>
         <tr>
            <th data-sort-key="<.normedLastName">Nachname</th>
            <th data-sort-key="<.normedFirstName">Vorname</th>
            <th data-sort-key=">.absences[0][0]" class="bl-2">✔</th>
            <th data-sort-key=">.absences[0][1]">✖</th>
            <th data-sort-key=">.absences[0][2]" class="sum">∑</th>
            <th data-sort-key=">.absences[1][0]" class="bl-2">✔</th>
            <th data-sort-key=">.absences[1][1]">✖</th>
            <th data-sort-key=">.absences[1][2]" class="sum">∑</th>
            <th data-sort-key=">.absences[2][0]" class="bl-2">✔</th>
            <th data-sort-key=">.absences[2][1]">✖</th>
            <th data-sort-key=">.absences[2][2]" class="sum br-2">∑</th>
         </tr></thead><tbody>
      `;

      for (let pupil of this.pupils) {
         html += `<tr data-pupil-id="${pupil.id}"><td>${pupil.lastName}</td><td>${pupil.firstName}</td>
            <td class="number bl-2">${pupil.absences[0][0]}</td><td class="number">${pupil.absences[0][1]}</td><td class="number sum br-2">${pupil.absences[0][2]}</td>
            <td class="number bl-2">${pupil.absences[1][0]}</td><td class="number">${pupil.absences[1][1]}</td><td class="number sum br-2">${pupil.absences[1][2]}</td>
            <td class="number bl-2">${pupil.absences[2][0]}</td><td class="number">${pupil.absences[2][1]}</td><td class="number sum br-2">${pupil.absences[2][2]}</td></tr>`;
      }

      html += '</tbody></table></absences>';

      this.panel.querySelector('.absences').innerHTML = html;

      this.panel.querySelectorAll('th').forEach(elTh => {
         const indexColor = [ .5, .3, .2 ];
         for (let i=0; i<this.sortKeys.length; ++i) {
            if (elTh.dataset.sortKey === this.sortKeys[i]) {
               elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[i]})`;
            }
         }
      });

      this.panel.querySelectorAll('.absences thead th').forEach(elTh => {
         let sortKey = elTh.dataset.sortKey;
         if (sortKey) {
            elTh.onclick = () => this.collectSortKey(elTh, sortKey);
         }
      });      

      this.panel.querySelectorAll('.absences tbody td').forEach(elTd => elTd.onclick = (event) => {
         this.showAbsenceDetails(parseInt(event.currentTarget.parentNode.dataset.pupilId));
      });

   }

   showAbsenceDetails(pupilId) {

      let data = this.data.filter(item => item.pupilId === pupilId);
      let pupil = this.app.dm.getUser(pupilId);
      if (pupilId) new ModalShowDayAbsenceDetails(this.app, pupil, data);

   }

   collectSortKey(elTh, sortKey) {

      const indexColor = [ .5, .3, .2 ];

      if (!this.collectingSortKeys) {
         this.sortKeys = [ sortKey ];
         this.collectingSortKeys = true;
         setTimeout(() => {
            this.collectingSortKeys = false;
            this.updateAbsences();
         }, 1500);
         this.panel.querySelectorAll('th').forEach(elTh => elTh.style.removeProperty('background-color'));
         elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[0]})`;
      }
      else {
         if (!this.sortKeys.includes(sortKey) && this.sortKeys.length < 3) {
            this.sortKeys.push(sortKey);
            elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[this.sortKeys.length-1]})`;
         }
      }

   }

}
